<template>
  <div class="group-list mt-3">
    <GroupItem @onUngroupSuccess="onUngroupSuccess" v-for="(group, index) in groups" :key="index" :group="group" :pageType="pageType" @onClickGroupItem="onClickGroupItem" />
  </div>
</template>

<script>
import GroupItem from "./GroupItem";
export default {
  name: "GroupList",
  components: {
    GroupItem
  },
  props: {
    groups: Array,
    pageType: String
  },
  methods: {
    onClickGroupItem(group) {
      this.$emit("onClickGroupItem", group);
    },
    onUngroupSuccess(){
      this.$emit("onUngroupSuccess");
    }
  }
};
</script>

<style lang="scss" scoped>
.group-list {
}
</style>
